module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Stop-cc6f969b0cd63e48dcc632c4df66b71d.svg";